import { VersionedTransaction } from '@solana/web3.js';
import { getConnection } from '@/helpers/solana/getConnection';
import {
  getLatestBlockhash,
  getLatestBlockheight,
} from '@/helpers/solana/getLatestBlockHash';
import { useWallet } from 'solana-wallets-vue';
import { snackbarPush } from '@/helpers/snackbarPush';

export function useConfirmTransaction() {
  const { sendTransaction } = useWallet();

  const confirmTransaction = async (
    txn: VersionedTransaction,
    successMsg?: string,
  ) => {
    try {
      const [signature, blockhash, lastValidBlockHeight] = await Promise.all([
        sendTransaction(txn, getConnection()),
        getLatestBlockhash(),
        getLatestBlockheight(),
      ]);

      const result = await getConnection().confirmTransaction({
        blockhash,
        lastValidBlockHeight,
        signature,
      });

      if (result.value.err) {
        throw result.value.err;
      } else {
        snackbarPush(successMsg || 'Successful transaction.');
      }
    } catch (err) {
      throw err;
    }
  };

  return { confirmTransaction };
}
